/**
 * Pantalla: Mapa
 * Component: PantMapa.tsx
 * Llenguatge: TypeScrypt
 * Autors: Jordi Riu
 * Versió: 1.1
 * Data: 19/12/2017
 * (c) Ajuntament de Manresa - dic 2017 - Departament de Sistemes d'Informació
 * Per mostrar indicadors en un mapa
 */

import * as React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Button, Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, IconButton, Menu, MenuItem, Tooltip, Typography } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { MapComponent } from '@terrestris/react-geo';
import OlLayerImage from 'ol/layer/Image';
import OlImageSource from 'ol/source/Image';
import OlLayerTile from 'ol/layer/Tile';
import OlTileSource from 'ol/source/Tile';
import { IPropsMapa } from '../interfaces/IPropsMapa';
import MapaState from '../states/MapaState';
import RefCadAdrWidget from '../controls/RefCadAdrWidget';
import MyLayerSwitcher from '../controls/MyLayersSwitcher';
import MyLayerSwitcher2 from '../controls/MyLayersSwitcher2';
import MyZoomToExtent from '../controls/MyZoomToExtent';
import MyCustomControl from '../controls/MyCustomControl';
import HorizontalCollapse from '../controls/HorizontalCollapse';
import { IFincaNumero } from '../interfaces/IRefCadAdr';
import 'ol/ol.css';
import 'antd/dist/antd.min.css';
import '../css/react-geo.css';
import '../css/MyControls.css';
import '../css/Mapa.css';
import '../css/Guia.css';
import { EnvironmentOutlined, CloseOutlined, FullscreenExitOutlined, CameraOutlined } from '@ant-design/icons'
import { ExpandMore, ArrowBackIos, ArrowForwardIos, Link, GpsFixed } from '@material-ui/icons';
import { ILayer, ILayerGroup, IUrl } from '../interfaces/ILayer';
import { AppDrawer, AppToolBar, AppToolBarElements } from 'ajt-app';
import Util from '../config/util';
import CotaIcon from '@material-ui/icons/SettingsEthernet';
import AreaIcon from '@material-ui/icons/AspectRatio';

@inject('appState')
@observer
export default class PantMapa extends React.Component<IPropsMapa, object> {
    constructor(props: IPropsMapa) {
        super(props);
        // Creem el mState - Els paràmetres el processem dins de createMap de MapaState
        this.mState = new MapaState(this.props, this.props.match.params.conf);
        // Events pel canvi de mida de la pantalla
        this.mState.updateWindowSize();
        this.autoSize = true;
    }
 
    // El estat del mapa
    private mState: MapaState;
 
    // Diu si agafem les mides de la pantalla
    private autoSize = false;
    private readonly resizeHandler = this.updateDimensions.bind(this);

    updateDimensions() {
        if (this.autoSize) {
            this.mState.updateWindowSize();
        }
    }
    
    // Per posar si cal la resposta a l'event de resize
    componentDidMount() {
        if (this.autoSize) {
            window.addEventListener('resize', this.resizeHandler);
        }
    }
      
    // Per treure si cal la resposta a l'event de resize
    componentWillUnmount() {
        if (this.autoSize) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }
    
    // Hem canviat de BaseLayer
    private handleBaseLayerChanged = (layerSelected: OlLayerTile<OlTileSource> | OlLayerImage<OlImageSource>) => {
       this.mState.actBaseLayer = layerSelected;
       // La capa de noms només la volem activa als layers de Planejament i Ortofoto
        if (this.mState.nomsLayer) {
            const id: string = layerSelected.get('id');
            const ld: ILayer = this.mState.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
            if (ld && ld.noms) {
               this.mState.nomsLayer.set('visible', this.mState.nomsVisible);
               this.mState.setShowNoms(true);
            } else {
               this.mState.nomsLayer.set('visible', false);
               this.mState.setShowNoms(false);
            }
        }
    }

    // Hem triat una finca o una adreça del control de text
    private handleOnChange = (e?: IFincaNumero) => {
        if (e) {
            if (e.NUMCOD) {
                // console.log('NUMCOD: ' + e.NUMCOD);
                this.mState.setFIDFromNumCod(e.NUMCOD);
                this.mState.setHCExpanded(false);
            } else if (e.FINCOD) {
                // console.log('FINCOD: ' + e.FINCOD);
                this.mState.setFIDFromFinCod(e.FINCOD);
                this.mState.setHCExpanded(false);
            } else if (e.FINREFCAD1 && e.FINREFCAD2) {
                // console.log('FINREFCAD: ' + e.FINREFCAD1 + ' ' + e.FINREFCAD2);
                this.mState.setFIDFromRefCad(e.FINREFCAD1, e.FINREFCAD2);
                this.mState.setHCExpanded(false);
            } else if (e.COORD && e.COORD.length === 2) {
                // console.log('COORD: ' + e.COORD);
                this.mState.setFIDFromPos(e.COORD);
                this.mState.setHCExpanded(false);
           } else {
            // console.log('RES(1)');
            this.mState.setFIDFromNumCod(0);
            }
        } else {
            // console.log('RES(2)');
            this.mState.setFIDFromNumCod(0);
        }
    }
 
    // Anar a la posició actual del mòbil
    private handleGotoMyLocation = () => {
        this.mState.setActualLocation();
    }

    // Començar a buscar una posició
    private handleMyShowPhoto = () => {
        this.mState.setIdentPosition(3);
    }

    // Començar a buscar una posició
    private handleMySetPosition = () => {
        this.mState.setIdentPosition(1);
    }

    // Esborrar la posició
    private handleMyDelPosition = () => {
        this.mState.setIdentPosition(0);
        this.mState.pParada = '';
    }

    // Recentrar mapa
    private handleMyCenterPosition = () => {
        this.mState.zoomToPosition();
    }
    
    // Per posar l'estat del HorizontalCollapse
    private handleHCToggle = () => {
        this.mState.setHCExpanded(!this.mState.hcExpanded);
    }
 
    // Activem o desactivem la capa de noms
    private handleCBNomsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.mState.nomsLayer.setVisible(event.target.checked);
        this.mState.setNomsVisible(event.target.checked);
    };

    // Activem o desactivem una capa de referència
    private handleCBRefLayerChange = (id: string, event: React.ChangeEvent<HTMLInputElement>) => {
        const i = this.mState.getRefLayerIndex(id);
        if (i >= 0) {
            this.mState.refLayers[i].setVisible(event.target.checked);
            this.mState.setRefLayerVisible(i, event.target.checked, true);
        }
    }

    // Rederitza un Layer o un LayerGroup
    private renderLayerComponent = (ly: ILayer | ILayerGroup) => {
        if (ly.type === 'wms' || ly.type === 'wmts') {
            const rll: ILayer = ly as ILayer;
            if (rll.legend && rll.legend.length > 0) {
                return (<Accordion square elevation={0} style={{padding: 0, minHeight: 20}} key={'ac' + rll.id}>
                    <AccordionSummary key={'gr' + rll.id} expandIcon={<ExpandMore />} style={{height: 32, maxHeight: 32, minHeight: 20}}>
                        <FormControlLabel 
                            style={{fontSize: '12px', padding: 0, marginLeft: -6}} 
                            key={'fcl' + rll.id}
                            control={<><Checkbox 
                                key={'cb' + rll.id}
                                checked={this.mState.actRefLayers[this.mState.getRefLayerIndex(rll.id)]} 
                                onChange={this.handleCBRefLayerChange.bind(this, rll.id)} 
                                name={rll.id}
                                style={{padding: 0}}  
                            />{!!rll.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rll.icon} alt={rll.name} width={16} height={16}/>&nbsp;</>}</>}
                            label={<Typography variant="body2">{rll.name}</Typography>} 
                        />
                    </AccordionSummary>
                    <AccordionDetails style={{display: 'grid', padding: '0px 16px 0px 16px', minHeight: 20}} key={'acd' + rll.id}>
                        {rll.legend.map((lg) => { return (<FormControlLabel 
                            style={{fontSize: '12px', padding: 0, marginLeft: 10}} 
                            key={'fclg' + lg.name}
                            control={<>{!!lg.icon && <><img src={process.env.PUBLIC_URL + '/img/' + lg.icon} alt={lg.name} width={16} height={16}/>&nbsp;</>}</>}
                            label={<Typography variant="body2">{lg.name}</Typography>} 
                        />); })}
                    </AccordionDetails>
                </Accordion>);
            } else {
                return (<Accordion square elevation={0} style={{padding: 0, minHeight: 20}} expanded={false} key={'ac' + rll.id}>
                    <AccordionSummary key={'gr' + rll.id} style={{height: 32, maxHeight: 32, minHeight: 20}}>
                        <FormControlLabel 
                            style={{fontSize: '12px', padding: 0, marginLeft: -6}} 
                            key={'fcl' + rll.id}
                            control={<><Checkbox 
                                key={'cb' + rll.id}
                                checked={this.mState.actRefLayers[this.mState.getRefLayerIndex(rll.id)]} 
                                onChange={this.handleCBRefLayerChange.bind(this, rll.id)} 
                                name={rll.id}
                                style={{padding: 0}}  
                            />{!!rll.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rll.icon} alt={rll.name} width={16} height={16}/>&nbsp;</>}</>}
                            label={<Typography variant="body2">{rll.name}</Typography>} 
                        />
                    </AccordionSummary>
                </Accordion>);
            }
        } else if (ly.type === 'grp') {
            const rlg = ly as ILayerGroup;
            return (<Accordion square elevation={0} style={{padding: 0, minHeight: 20}} key={'ac' + rlg.id}>
                <AccordionSummary key={'gr' + rlg.id} expandIcon={<ExpandMore />} style={{height: 32, maxHeight: 32, minHeight: 20}}>
                    {!!rlg.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rlg.icon} alt={rlg.name} width={16} height={16}/>&nbsp;</>}
                    <Typography variant="body2">{rlg.name}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{display: 'grid', padding: 0, minHeight: 20}} key={'acd' + rlg.id}>
                    {rlg.layers.map((rl) => { return this.renderLayerComponent(rl); })}
                </AccordionDetails>
            </Accordion>);
        } else {
            return null;
        }
    }

    // Retrona el nom del layer si està actiu. si és un grup retorna els noms dels layers actius de dins del grup
    private getActiveLayer = (ly: ILayer | ILayerGroup): string => {
        if (ly.type === 'wms' || ly.type === 'wmts') {
            const rll: ILayer = ly as ILayer;
            if (this.mState.actRefLayers[this.mState.getRefLayerIndex(rll.id)]) {
                return rll.layers;
            }
        } else if (ly.type === 'grp') {
            const rlg = ly as ILayerGroup;
            const lys: Array<string> = rlg.layers.map((rl) => { return this.getActiveLayer(rl); });
            if (lys.length > 0) {
                let slys: string = lys.join(',');
                let slys2: string = Util.replaceAll(slys, ',,', ',');
                while (slys !== slys2) {
                    slys = slys2;
                    slys2 = Util.replaceAll(slys, ',,', ',');
                }
                if (slys.endsWith(',')) {
                    slys = slys.substring(0, slys.length - 1);
                }
                return slys;
            }
        }
        return '';
    }

    private handlePhotoClose = () => {
        this.mState.photoIndex = -1;
        this.mState.photoArray = [];
        this.mState.photoAdr = '';
    }

    private handlePhotoBack = () => {
        let i = this.mState.photoIndex - 1;
        if (i < 0) {
            i = this.mState.photoArray.length - 1;
        }
        this.mState.photoIndex = i;
    }

    private handlePhotoFordward = () => {
        let i = this.mState.photoIndex + 1;
        if (i >=  this.mState.photoArray.length) {
            i = 0;
        }
        this.mState.photoIndex = i;
    }

    private handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.mState.setAnchorEl(event.currentTarget)
    }

    private handleMenuClose = (index: number) => {
        this.mState.setAnchorEl(null);
        if (index >= 0) {
            window.open(this.mState.mapConfig.descarrega[index].url, this.mState.mapConfig.descarrega[index].name);
        }
    }

    /** Dibuixem mesures
     * @param measureType Tipus de mesura
     */
    private handleMeasureMenuItemClick = (measureType: string) => {
        this.mState.setMapInteraction(measureType);
    };
    
    // Mostra un diàleg amb l'enllaç
    private handleGetLink = () => {
        // Posar un popup amb el link
        // Protocol i host
        let url: string = window.location.protocol + '//' + window.location.hostname;
        // Port
        if (window.location.port && window.location.port !== '80' && window.location.port != '443') {
            url += ':' + window.location.port;
        }
        // Path
        url += window.location.pathname;
        // Centre del mapa i Zoom
        const c = this.mState.olview.getCenter();
        url += '?Pos=' + c[0].toFixed(2) + ';' + c[1].toFixed(2) + ';' + this.mState.olview.getZoom().toFixed(0);
        // Marcador
        if (this.mState.position) {
            url += ';' + this.mState.position[0].toFixed(2) + ';' + this.mState.position[1].toFixed(2);
        }
        // BaseLayer
        const id: string = this.mState.actBaseLayer.get('id');
        const ld: ILayer = this.mState.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
        url += '&Base=' + ld.layers;
        // RefLayers
        const lys: Array<string> = this.mState.mapConfig.refLayers.map((rl) => {
            return this.getActiveLayer(rl);
        })
        if (lys.length > 0) {
            let slys: string = lys.join(',');
            let slys2: string = Util.replaceAll(slys, ',,', ',');
            while (slys !== slys2) {
                slys = slys2;
                slys2 = Util.replaceAll(slys, ',,', ',');
            }
            if (slys.endsWith(',')) {
                slys = slys.substring(0, slys.length - 1);
            }
            if (slys.startsWith(',')) {
                slys = slys.substring(1);
            }
            if (slys) {
                url+= '&Layers=' + slys;
            }
        }
        // Parada
        if (this.mState.pParada) {
            url += '&Parada=' + this.mState.pParada;
        }

        this.props.appState.dialState.messageBox({    
            title: 'Enllaç',
            message: url,
            buttons: navigator.clipboard ? ['Copiar URL', 'Acceptar'] : ['Acceptar']
        }).then((result) => {
            if (result === 'Copiar URL') {
                navigator.clipboard.writeText(url);
                this.props.appState.notiState.showMessage('URL copiada');
            }
        });
    }

    render () {
        if (!this.mState.configOk) {
            return null;
        }

        const w: number = this.mState.width; // Amplada de la finestra
        const drw: number = this.props.appState.menuState.marginDrawer; // Amplada el drawer
        const wx: string = (w - drw).toString() + 'px'; // Amplada del mapa
        const mto: string = w < 601 ? (w < 600 ? '96px' : '112px') : '112px'; // Posició top del mapa
        const h: number = this.mState.height - 106 + (w < 601 ? (w < 600 ? 16 : 8) : 0); // Alçada del mapa
        const hx: string = h.toString() + 'px'; // Alçada del mapa

        const lx: string = w < 601 ? '.5em' : 'calc(50% - ' + ((w / 2) - 270) + 'px)'; // Esquerra del layer switcher
        const bx: string = 'calc(100% - ' + (h + ( w < 601 ? 80 : 90)).toString() + 'px)'; // Bottom del layer switcher

        const txr = w < 601 ? (w < 600 ? '106px' : '122px') : '122px'; // Top del cercador
        const lxr: string = w < 601 ? '2.5em' : 'calc(50% - ' + ((w / 2) - 300) + 'px)'; // Esquerra del cercador
        const wxr = (w - (w < 601 ? 45 : 310)).toString() + 'px'; // Amplada del crecador quan està desplegat

        const thc = w < 601 ? (w < 600 ? '106px' : '122px') : '122px';  // Posició (superior) del control de capa de noms
        const rhc = 'calc(100% - ' + (w + 5).toString() + 'px)'; // Posició (dreta) del control de capa de noms

        return (
            <>
                <AppToolBar style={{zIndex: 1300}} showHelp={true}>
                    <AppToolBarElements alignment='right'>
                        {this.mState.mapConfig.measureTool && <Tooltip title="Mesurar longitud">
                            <IconButton onClick={this.handleMeasureMenuItemClick.bind(this, 'l')} key="mdistance">
                                <CotaIcon />
                            </IconButton>
                        </Tooltip>}
                        {this.mState.mapConfig.measureTool && <Tooltip title="Mesurar àrea">
                            <IconButton onClick={this.handleMeasureMenuItemClick.bind(this, 'a')} key="marea">
                                <AreaIcon />
                            </IconButton>
                        </Tooltip>}
                        {this.mState.mapConfig.descarrega && this.mState.mapConfig.descarrega.length > 0 && <><Button onClick={this.handleMenuClick}>Descàrrega de mapes ...</Button>
                            <Menu
                                id="simple-menu"
                                anchorEl={this.mState.anchorEl}
                                keepMounted
                                open={Boolean(this.mState.anchorEl)}
                                onClose={this.handleMenuClose.bind(this, -1)}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                                transformOrigin={{ vertical: 'top', horizontal: 'center', }}
                            >
                                {this.mState.mapConfig.descarrega.map((item: IUrl, index: number) => {
                                    return (<MenuItem key={'dsc' + index} onClick={this.handleMenuClose.bind(this, index)}>{item.name}</MenuItem>);
                                })}
                            </Menu>
                        </>}
                        <Tooltip title="Enllaçar">
                            <IconButton onClick={this.handleGetLink} key="iblink">
                                <Link />
                            </IconButton>
                        </Tooltip>
                    </AppToolBarElements>
                </AppToolBar>
                <AppDrawer variant={ w < 601 ? 'temporary' : 'permanent'}>
                    {
                        this.mState.mapConfig.refLayers.map((rl) => {
                            return this.renderLayerComponent(rl);
                        })
                    }
                </AppDrawer>
                <>
                    {this.mState.refCadWebApi && <HorizontalCollapse
                        style={{zIndex: 2, backgroundColor: 'rgba(250, 250, 250, 0.8)', position: 'absolute', left: lxr, top: txr}}
                        expandedWidth={wxr}
                        expanded={this.mState.hcExpanded}
                        onToggleExpanded={this.handleHCToggle}
                        text={'Cercador'}
                    >
                        <RefCadAdrWidget
                            proxyWebApi={this.mState.refCadWebApi}
                            numCod={this.mState.numCod}
                            finCod={this.mState.finCod}
                            finRefCad1={this.mState.finRefCad1}
                            finRefCad2={this.mState.finRefCad2}
                            onChange={this.handleOnChange}
                            floatingLabelText="Cercar per adreça o referència cadastral"
                        />
                    </HorizontalCollapse>}
                    {this.mState.olmap && <MapComponent map={this.mState.olmap} style={{width: wx, height: hx, cursor: this.mState.identPosition ? 'crosshair' : this.mState.identElement ? 'pointer' : 'default', position: 'fixed', top: mto}}/>}
                    {this.mState.olmap && <MyZoomToExtent map={this.mState.olmap} tooltip="Zoom total" extent={this.mState.mapConfig.initialExtent}/>}
                    {this.mState.olmap && <MyCustomControl
                        map={this.mState.olmap} 
                        className="my-1-position" 
                        icon={GpsFixed}
                        tooltip="Anar a la posició actual"
                        onClick={this.handleGotoMyLocation}
                        key="mycc1"
                    />}
                    {this.mState.olmap && <MyCustomControl
                        map={this.mState.olmap} 
                        className="my-2-position" 
                        icon={CameraOutlined}
                        tooltip="Mostrar la fotografia de l'element o de la façana"
                        onClick={this.handleMyShowPhoto}
                        key="mycc2"
                    />}
                    {this.mState.olmap && <MyCustomControl
                        map={this.mState.olmap} 
                        className="my-3-position" 
                        icon={EnvironmentOutlined}
                        tooltip="Posar un marcador"
                        onClick={this.handleMySetPosition}
                        key="mycc3"
                    />}
                    {this.mState.olmap && !!this.mState.position && <MyCustomControl
                        map={this.mState.olmap} 
                        className="my-4-position" 
                        icon={CloseOutlined}
                        tooltip="Esborrar el marcador"
                        onClick={this.handleMyDelPosition}
                        hidden={!this.mState.position}
                        key="mycc4"
                    />}
                    {this.mState.olmap && !!this.mState.position && <MyCustomControl
                        map={this.mState.olmap} 
                        className="my-5-position" 
                        icon={FullscreenExitOutlined} 
                        tooltip="Centrar el mapa al marcador"
                        onClick={this.handleMyCenterPosition}
                        hidden={!this.mState.position}
                        key="mycc5"
                    />}
                    {this.mState.baseLayers.length === 2 && <MyLayerSwitcher
                        style={{
                            position: 'absolute',
                            bottom: bx,
                            left: lx,
                            zIndex: 2
                        }}
                        map={this.mState.olmap}
                        layers={this.mState.baseLayers}
                        onBaseLayerChanged={this.handleBaseLayerChanged}
                        key="myls1"
                    />}
                    {this.mState.baseLayers.length > 2 && <MyLayerSwitcher2 
                        style={{
                            position: 'absolute',
                            bottom: bx,
                            left: lx,
                            zIndex: 2,
                            backgroundColor: 'rgba(250, 250, 250, 0.8)'
                        }}
                        map={this.mState.olmap}
                        layers={this.mState.baseLayers}
                        onBaseLayerChanged={this.handleBaseLayerChanged}
                        key="myls2"
                    />}
                    {this.mState.showNoms && <FormControlLabel 
                        style={{zIndex: 1, backgroundColor: 'rgba(250, 250, 250, 0.9)', position: 'absolute', right: rhc, top: thc}}
                        control={<Checkbox 
                            checked={this.mState.nomsVisible} 
                            onChange={this.handleCBNomsChange} 
                            name="cbNoms"   
                        />}
                        label={<Typography variant="body2">{this.mState.nomsLayer.get('name')}</Typography>} 
                        title='Activar o desactivar la capa de noms de carrers i de números postals'
                    />}
                    {this.mState.photoIndex >= 0 && <Dialog 
                        onClose={this.handlePhotoClose}
                        open={this.mState.photoIndex >= 0}
                    >
                        <DialogTitle disableTypography style={{padding: '0px 0px 0px 24px'}}>
                            <span className={'guia-popup-content'}><b>{this.mState.photoAdr}</b></span>
                            <div className={'guia-popup-closer'} onClick={this.handlePhotoClose} />
                        </DialogTitle>
                        <DialogContent>
                            <img style={{maxWidth: '500px', maxHeight: '400px'}} src={this.mState.mapConfig.wsPhoto + '?Photo=' + this.mState.photoArray[this.mState.photoIndex] + '&Usuari=' + this.mState.usr + '&Session=' + this.mState.ses} />
                            {this.mState.photoArray.length > 1 && <>
                                <IconButton onClick={this.handlePhotoBack} style={{float: 'left', position: 'absolute', left: '10px', top: '50%'}} key="ib1">
                                    <ArrowBackIos />
                                </IconButton>
                                <IconButton onClick={this.handlePhotoFordward} style={{float: 'right', position: 'absolute', right: '10px', top: '50%'}} key="ib2">
                                    <ArrowForwardIos />
                                </IconButton>
                            </>}
                        </DialogContent>
                    </Dialog>}
                </>
            </>
        );
    }
}